import React from 'react'

function SpriteButton({toggleTwoD}) {
  return (
    <div 
      className='two-d text-center text-3xl text-white font-bold bg-black p-1 border-x-yellow-400 border-2 mt-2 text-center' 
      onClick={toggleTwoD}>
        2DS
    </div>
  )
}

export default SpriteButton